<template>
<div class="chapter">
<div class="inner_page">
<section>
<h1 class="navTitle">Payback</h1>
<h2 class="navTocTitle">Table of Contents</h2>
<nav epub:type="toc" id="toc">
<ol id="tocList">
<li class="navTocItem"><span href="#/cover" title="Link target outside of Sample"><span class="a-inner">Cover</span></span></li>
<li class="navTocItem"><a href="#/chapter0" title="Title Page"><span class="a-inner">Title Page</span></a></li>
<li class="navTocItem"><a href="#/chapter1" title="Prologue"><span class="a-inner">Prologue</span></a></li>
<li class="navTocItem"><a href="#/chapter2" title="Chapter One"><span class="a-inner">Chapter One</span></a></li>
<li class="navTocItem"><a href="#/chapter3" title="Chapter Two"><span class="a-inner">Chapter Two</span></a></li>
<li class="navTocItem"><a href="#/chapter4" title="Chapter Three"><span class="a-inner">Chapter Three</span></a></li>
<li class="navTocItem"><span href="#/chapter5" title="Link target outside of Sample"><span class="a-inner">Chapter Four</span></span></li>
<li class="navTocItem"><span href="#/chapter6" title="Link target outside of Sample"><span class="a-inner">Chapter Five</span></span></li>
<li class="navTocItem"><span href="#/chapter7" title="Link target outside of Sample"><span class="a-inner">Chapter Six</span></span></li>
<li class="navTocItem"><span href="#/chapter8" title="Link target outside of Sample"><span class="a-inner">Chapter Seven</span></span></li>
<li class="navTocItem"><span href="#/chapter9" title="Link target outside of Sample"><span class="a-inner">Chapter Eight</span></span></li>
<li class="navTocItem"><span href="#/chapter10" title="Link target outside of Sample"><span class="a-inner">Chapter Nine</span></span></li>
<li class="navTocItem"><span href="#/chapter11" title="Link target outside of Sample"><span class="a-inner">Chapter Ten</span></span></li>
<li class="navTocItem"><span href="#/chapter12" title="Link target outside of Sample"><span class="a-inner">Chapter Eleven</span></span></li>
<li class="navTocItem"><span href="#/chapter13" title="Link target outside of Sample"><span class="a-inner">Chapter Twelve</span></span></li>
<li class="navTocItem"><span href="#/chapter14" title="Link target outside of Sample"><span class="a-inner">Chapter Thirteen</span></span></li>
<li class="navTocItem"><span href="#/chapter15" title="Link target outside of Sample"><span class="a-inner">Chapter Fourteen</span></span></li>
<li class="navTocItem"><span href="#/chapter16" title="Link target outside of Sample"><span class="a-inner">Chapter Fifteen</span></span></li>
<li class="navTocItem"><span href="#/chapter17" title="Link target outside of Sample"><span class="a-inner">Chapter Sixteen</span></span></li>
<li class="navTocItem"><span href="#/chapter18" title="Link target outside of Sample"><span class="a-inner">Chapter Seventeen</span></span></li>
<li class="navTocItem"><span href="#/chapter19" title="Link target outside of Sample"><span class="a-inner">Chapter Eighteen</span></span></li>
<li class="navTocItem"><span href="#/chapter20" title="Link target outside of Sample"><span class="a-inner">Chapter Nineteen</span></span></li>
<li class="navTocItem"><span href="#/chapter21" title="Link target outside of Sample"><span class="a-inner">Chapter Twenty</span></span></li>
<li class="navTocItem"><span href="#/chapter22" title="Link target outside of Sample"><span class="a-inner">Chapter Twenty One</span></span></li>
<li class="navTocItem"><span href="#/chapter23" title="Link target outside of Sample"><span class="a-inner">Chapter Twenty Two</span></span></li>
<li class="navTocItem"><span href="#/chapter24" title="Link target outside of Sample"><span class="a-inner">Chapter Twenty Three</span></span></li>
<li class="navTocItem"><span href="#/chapter25" title="Link target outside of Sample"><span class="a-inner">Chapter Twenty Four</span></span></li>
<li class="navTocItem"><span href="#/chapter26" title="Link target outside of Sample"><span class="a-inner">Chapter Twenty Five</span></span></li>
<li class="navTocItem"><span href="#/chapter27" title="Link target outside of Sample"><span class="a-inner">Author’s note</span></span></li>
<li class="navTocItem"><span href="#/chapter28" title="Link target outside of Sample"><span class="a-inner">Next in Series</span></span></li>
<li class="navTocItem"><span href="#/chapter29" title="Link target outside of Sample"><span class="a-inner">Copyright</span></span></li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<h2>Guide</h2>
<ol id="landmarksList">
<li><span epub:type="cover" href="#/cover" title="Link target outside of Sample">Cover</span></li>
<li><a epub:type="bodymatter" href="#/chapter0">Title Page</a></li>
</ol>
</nav>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?6381d5c2